const SCAN_ALERT_DISMISSED_KEY = 'scanAlert.dismissed'

export const getScanAlertDismissed = (): boolean => {
  try {
    return sessionStorage.getItem(SCAN_ALERT_DISMISSED_KEY) === 'true'
  } catch {
    return false
  }
}

export const setScanAlertDismissed = (dismissed: boolean): void => {
  try {
    if (dismissed) {
      sessionStorage.setItem(SCAN_ALERT_DISMISSED_KEY, 'true')
    } else {
      sessionStorage.removeItem(SCAN_ALERT_DISMISSED_KEY)
    }
  } catch {
    // Silently fail if sessionStorage unavailable
  }
}

export const clearScanAlertDismissed = (): void => {
  try {
    sessionStorage.removeItem(SCAN_ALERT_DISMISSED_KEY)
  } catch {
    // Silently fail
  }
}
